<template>
  <div id="filter-parent">
    <span class="filter-reset">
      <span class="filter-heading">Filters</span>
      <span style="cursor:pointer" @click="reset" class="reset-button"
        >Reset</span
      >
    </span>
    <span class="search-filter">
      <input
        class="inputbox-filter"
        placeholder="Type here to search..."
        v-model="searchInput"
        @keyup="searchFunction"
        @change="searchFunction"
      />
      <v-icon class="search-icon-filter" color="black" @click="searchFunction"
        >search</v-icon
      >
    </span>
    <span class="price-range">
      <span class="price-range-heading">Price Range</span>
      <v-range-slider
        v-model="range"
        :max="max"
        :min="min"
        color="#4415e5"
        thumb-color="#D3D3D3"
        hide-details
        class="align-center"
        @change="priceRange"
      ></v-range-slider>
      <span class="range-data">
        <span class="range-data-font">&#8377; {{ range[0] }}</span>
        <span class="range-data-font">&#8377; {{ range[1] }}</span>
      </span>
    </span>
    <span class="dropdown-filters">
      <span
        class="filter-heading-event"
        ref="categories"
        v-b-toggle.filter-categories
        @click="rotateArrow"
      >
        <span class="dropdown-filter-name">Categories</span>
        <span>
          <img src="../assets/filter/down-arrow.svg" />
        </span>
      </span>
      <b-collapse id="filter-categories" class="mt-2" :visible="false">
        <b-form-checkbox
          v-for="(option, idx) in uniqueCat"
          v-model="selectedCat"
          :key="idx"
          :value="option.category"
          @change="filterCheckBox(option.category)"
          >{{ option.category }}</b-form-checkbox
        >
      </b-collapse>
    </span>
    <span class="dropdown-filters">
      <span
        class="filter-heading-event"
        ref="subcategory"
        v-b-toggle.filter-subcategories
        @click="rotateArrow"
      >
        <span class="dropdown-filter-name">Subcategories</span>
        <span>
          <img src="../assets/filter/down-arrow.svg" />
        </span>
      </span>
      <b-collapse id="filter-subcategories" class="mt-2">
        <b-form-checkbox
          v-for="(option, idx) in uniqueSubCat"
          v-model="selectedSubCat"
          :key="idx"
          :value="option.subcategory"
          @change="filterCheckBox(option.subcategory)"
          >{{ option.subcategory }}</b-form-checkbox
        >
      </b-collapse>
    </span>
  </div>
</template>

<script>
export default {
  data() {
    return {
      min: 0,
      max: 5000000,
      range: [0, 5000000],
      searchInput: "",
      selectedCat: [],
      selectedSubCat: [] // Must be an array reference!
    };
  },
  computed: {
    uniqueSubCat() {
      return _.uniqBy(this.$store.state.products, "subcategory");
    },
    uniqueCat() {
      return _.uniqBy(this.$store.state.products, "category");
    }
  },
  created() {
    this.$store.state.afterfilterEmpty = false;
    this.$store.state.filterProducts = [];
    this.$store.state.filterProductsWithPrice = [];

    if (this.$store.state.globalCat !== "") {
      if (this.$store.state.globalCat !== "All") {
        this.customCheckBoxingCat(this.$store.state.globalCat);
      }
    }
    if (this.$store.state.globalSubCat !== "") {
      this.customCheckBoxingSubCat(this.$store.state.globalSubCat);
      console.log(this.$store.state.globalSubCat);
    }

    setTimeout(() => {
      if (this.$store.state.globalSearch !== "") {
        this.searchInput = this.$store.state.globalSearch;
        this.$store.state.globalSearch = "";
        this.searchFunction();
      }
      if (this.$store.state.ismobile == false) {
        document.getElementById("search-navbar").style.visibility = "hidden";
      } else {
        document.getElementById("searchIcon").style.visibility = "hidden";
      }
    }, 700);
  },
  destroyed() {
    if (this.$store.state.ismobile == false) {
      document.getElementById("search-navbar").style.visibility = "visible";
    } else {
      document.getElementById("searchIcon").style.visibility = "visible";
    }
    this.$store.state.globalCat = "";
    this.$store.state.globalSubCat = "";
  },
  methods: {
    priceRange() {
      if (this.$store.state.filterProducts.length > 0) {
        var temp = [];
        this.$store.state.filterProducts.forEach(e => {
          if (e.price > this.range[0] && e.price < this.range[1]) {
            temp.push(e);
          }
        });
        if (this.range[0] == 0 && this.range[1] == 5000000) {
          this.$store.state.filterProductsWithPrice = [];
        } else {
          if (temp.length > 0) {
            this.$store.state.filterProductsWithPrice = temp;
          } else {
            this.$store.state.filterProductsWithPrice = [];
            this.$store.state.afterfilterEmpty = true;
            this.$store.state.filterProducts = [];
            // this.range = [0, 5000000];
            // this.searchInput = ''
          }
        }
      } else {
        var temp = [];
        this.$store.state.products.forEach(e => {
          if (e.price > this.range[0] && e.price < this.range[1]) {
            temp.push(e);
          }
        });
        console.log(temp.length);
        if (temp.length > 0) {
          this.$store.state.filterProductsWithPrice = temp;
        } else {
          this.$store.state.filterProductsWithPrice = [];
          this.$store.state.filterProducts = [];
          this.$store.state.afterfilterEmpty = true;
        }
      }
    },
    filterCheckBox(e) {
      if (this.selectedCat.includes(e) || this.selectedSubCat.includes(e)) {
        this.range = [0, 5000000];
        this.$store.state.filterProductsWithPrice = [];
        if (this.selectedCat.includes(e)) {
          this.$store.state.filterProducts = this.$store.state.filterProducts.filter(
            item => item.category.toLowerCase() !== e.toLowerCase()
          );
        }
        if (this.selectedSubCat.includes(e)) {
          this.$store.state.filterProducts = this.$store.state.filterProducts.filter(
            item => item.subcategory.toLowerCase() !== e.toLowerCase()
          );

          console.log(this.selectedCat);
          console.log(this.selectedSubCat);
        }
      }
      setTimeout(() => {
        this.range = [0, 5000000];
        this.$store.state.filterProducts = [];
        this.$store.state.filterProductsWithPrice = [];
        if (this.selectedCat.length > 0) {
          var temp = [];
          if (this.selectedSubCat.length > 0) {
            this.selectedCat.forEach(i => {
              this.$store.state.products.forEach(j => {
                if (this.selectedSubCat.includes(j.category)) {
                  if (
                    !this.$store.state.filterProducts.includes(j) &&
                    j.price > this.range[0] &&
                    j.price < this.range[1]
                  )
                    this.$store.state.filterProducts.push(j);
                }
              });
            });
          } else {
            this.selectedCat.forEach(i => {
              this.$store.state.products.forEach(j => {
                if (j.category.toLowerCase() == i.toLowerCase()) {
                  if (
                    !this.$store.state.filterProducts.includes(j) &&
                    j.price > this.range[0] &&
                    j.price < this.range[1]
                  )
                    this.$store.state.filterProducts.push(j);
                }
              });
            });
          }
        }
        if (this.selectedSubCat.length > 0) {
          var temp = [];
          if (this.selectedCat.length > 0) {
            console.log("here");
            this.$store.state.filterProducts = [];

            this.selectedSubCat.forEach(i => {
              this.$store.state.products.forEach(j => {
                if (
                  this.selectedCat.includes(j.category) &&
                  this.selectedSubCat.includes(j.subcategory)
                ) {
                  console.log(j.category);

                  if (
                    !this.$store.state.filterProducts.includes(j) &&
                    j.price > this.range[0] &&
                    j.price < this.range[1]
                  )
                    this.$store.state.filterProducts.push(j);
                }
              });
            });
          } else {
            this.selectedSubCat.forEach(i => {
              this.$store.state.products.forEach(j => {
                if (j.subcategory.toLowerCase() == i.toLowerCase()) {
                  if (
                    !this.$store.state.filterProducts.includes(j) &&
                    j.price > this.range[0] &&
                    j.price < this.range[1]
                  )
                    this.$store.state.filterProducts.push(j);
                }
              });
            });
          }
        }
      }, 500);
    },
    customCheckBoxingCat(e) {
      var isInclude = false;
      this.uniqueCat.forEach(element => {
        if (element.category == e) {
          isInclude = true;
        }
      });

      if (isInclude == true) {
        setTimeout(() => {
          this.range = [0, 5000000];
          this.$store.state.filterProductsWithPrice = [];
          var temp = [];
          this.selectedCat = [e];
          console.log(this.selectedCat);

          this.selectedCat.forEach(i => {
            this.$store.state.products.forEach(j => {
              if (j.category.toLowerCase() == i.toLowerCase()) {
                if (
                  !this.$store.state.filterProducts.includes(j) &&
                  j.price > this.range[0] &&
                  j.price < this.range[1]
                )
                  this.$store.state.filterProducts.push(j);
              }
            });
          });
        }, 500);
        setTimeout(() => {
          this.$refs.categories.click();
        }, 0);
      } else {
        this.$store.state.afterfilterEmpty = true;
      }
    },
    customCheckBoxingSubCat(e) {
      var isInclude = false;
      this.uniqueSubCat.forEach(element => {
        if (element.subcategory == e) {
          isInclude = true;
        }
      });

      if (isInclude == true) {
        setTimeout(() => {
          this.range = [0, 5000000];
          this.$store.state.filterProductsWithPrice = [];
          var temp = [];
          this.selectedSubCat = [e];
          console.log(this.selectedSubCat);

          this.selectedSubCat.forEach(i => {
            this.$store.state.products.forEach(j => {
              if (j.subcategory.toLowerCase() == i.toLowerCase()) {
                if (
                  !this.$store.state.filterProducts.includes(j) &&
                  j.price > this.range[0] &&
                  j.price < this.range[1]
                )
                  this.$store.state.filterProducts.push(j);
              }
            });
          });
        }, 500);
        setTimeout(() => {
          this.$refs.subcategory.click();
        }, 0);
      } else {
        this.$store.state.afterfilterEmpty = true;
      }
    },
    searchFunction() {
      if (this.searchInput.length > 0) {
        this.range = [0, 5000000];
        console.log(this.searchInput);
        let product = this.$store.state.products;

        const filter = product =>
          (product.subcategory &&
            product.subcategory
              .toLowerCase()
              .includes(this.searchInput.toLowerCase())) ||
          (product.category &&
            product.category
              .toLowerCase()
              .includes(this.searchInput.toLowerCase())) ||
          (product.ad_location &&
            product.ad_location
              .toLowerCase()
              .includes(this.searchInput.toLowerCase())) ||
          (product.pincode &&
            product.pincode
              .toLowerCase()
              .includes(this.searchInput.toLowerCase())) ||
          (product.landmark &&
            product.landmark
              .toLowerCase()
              .includes(this.searchInput.toLowerCase()));

        this.$store.state.filterProducts = _.slice(
          this.$store.state.products.filter(filter),
          0,
          20
        );

        if (this.$store.state.filterProducts == 0) {
          this.$store.state.filterProducts = [];
          this.$store.state.afterfilterEmpty = true;
        } else {
          this.$store.state.afterfilterEmpty = false;
        }
      } else {
        this.range = [0, 5000000];
        this.$store.state.filterProducts = [];
        this.$store.state.filterProductsWithPrice = [];
      }
    },
    rotateArrow(e) {
      // console.log(e.target.nextElementSibling.firstChild);
      if (e.target.localName == "img") {
        if (Array.from(e.target.classList).includes("rotated")) {
          e.target.classList.remove("rotated");
        } else {
          e.target.classList.add("rotated");
        }
      } else if (
        e.target.nextElementSibling &&
        e.target.nextElementSibling.firstChild.localName == "img"
      ) {
        if (
          Array.from(e.target.nextElementSibling.firstChild.classList).includes(
            "rotated"
          )
        ) {
          e.target.nextElementSibling.firstChild.classList.remove("rotated");
        } else {
          e.target.nextElementSibling.firstChild.classList.add("rotated");
        }
      } else if (
        e.target.childNodes[1] &&
        e.target.childNodes[1].firstChild.localName == "img"
      ) {
        if (
          Array.from(e.target.childNodes[1].firstChild.classList).includes(
            "rotated"
          )
        ) {
          e.target.childNodes[1].firstChild.classList.remove("rotated");
        } else {
          e.target.childNodes[1].firstChild.classList.add("rotated");
        }
      }
    },
    reset() {
      this.$store.state.afterfilterEmpty = false;
      this.$store.state.filterProducts = [];
      this.$store.state.filterProductsWithPrice = [];
      this.searchInput = "";
      this.selectedSubCat = [];
      this.selectedCat = [];
      this.range = [0, 5000000];
    }
  }
};
</script>

<style scoped>
.rotated {
  transform: rotate(180deg);
}
#filter-parent {
  display: flex;
  flex-direction: column;
  width: 282px;
  background-color: #fafcfe;
  padding: 20px;
  height: 80vh;
}
.filter-reset {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin: 10px 0;
  align-items: center;
}
.filter-heading {
  font-size: 24px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  text-align: left;
  color: #000000;
}
.reset-button {
  font-size: 14px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  text-align: left;
  color: #4415e5;
}
.search-filter {
  margin: 10px 0;
  position: relative;
}
.inputbox-filter {
  outline: none;
  width: 100%;
  border-bottom: 1px solid;
  padding: 4px 0;
}
.search-icon-filter {
  position: absolute;
  right: 0;
}
.price-range {
  margin: 10px 0;
}
.price-range-heading {
  font-size: 16px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  text-align: left;
  color: #000000;
  margin: 10px 0;
}
.range-data {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
}
.range-data-font {
  font-size: 13px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  text-align: left;
  color: #000000;
}
.dropdown-filters {
  position: relative;
  margin: 10px 0;
}
.filter-heading-event {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
}
.dropdown-filter-name {
  font-size: 16px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  text-align: left;
  color: #000000;
}
</style>
